import React from "react";
import { Page } from "../../../components/common";
import { Step1, Step2, Step3, Step4, Step5, Step6 } from "./components";
import { useClient } from "../../../hooks";
import { get } from "lodash";
import { Alert } from "reactstrap";
import { useApplicationFormQuery } from "./hooks";
import { useSteps } from "../hooks";
import { handleNonFieldErrors } from "../util";
import { Step2a } from "./components/Step2a";

export const VolunteerApplicationFormView = ({ match }) => {
  const { id } = match.params;
  const url = `volunteer_application_forms/${id}`;
  const client = useClient();
  const { error, data, refetch } = useApplicationFormQuery(url);
  let steps;

  if (data && data.is_young_helper) {
    steps = [Step1, Step2a, Step5, Step6];
  } else {
    steps = [Step1, Step2, Step3, Step4, Step5, Step6];
  }

  const { nextStep, previousStep, step } = useSteps(0, steps);

  const container = (children) => (
    <Page title="Make Lunch Volunteer Application Form">{children}</Page>
  );

  if (error && get(error, "response.status") === 404) {
    return container(
      <Alert color="warning">This application form link is not valid.</Alert>
    );
  }

  if (!data) return null;

  async function onSubmit(x) {
    try {
      await client.patch(url, x);
    } catch (ex) {
      handleNonFieldErrors(ex);
    }
    await refetch();

    setTimeout(() => {
      nextStep();
    }, 0);
  }

  function onBack() {
    previousStep();
  }

  if (data.submitted) {
    return container(
      <>
        <h3 className="tw-font-medium tw-text-xl tw-mb-4">Thanks!</h3>
        <p>
          Thank you for taking the time to complete the application. One of our
          team will be in touch shortly.
        </p>
        <p>
          Please do not hesitate to contact us at{" "}
          <a href="mailto:makelunch.tlg.org.uk">makelunch.tlg.org.uk</a> if you
          have any questions.
        </p>
      </>
    );
  }

  return container(
    <>
      {steps.map((Component, index) => {
        if (index !== step) return null;
        return (
          <Component
            defaultValues={data}
            onSubmit={onSubmit}
            onBack={onBack}
            nextStep={nextStep}
            key={index}
          />
        );
      })}
    </>
  );
};
